/* eslint-disable @typescript-eslint/no-explicit-any */

export const MAP_POLYGON_STYLE = {
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#FF0000',
  fillOpacity: 0.35
};

export function geoLongLatFromPolygonPath(path: any): number[][] {
  const coordinates = path
    .getArray()
    .map((latLng: any) => [latLng.lng(), latLng.lat()]);

  if (coordinates.length) {
    coordinates.push([...coordinates[0]]);
  }

  return coordinates;
}

export function defaultPolygonAroundPoint(
  lat: number,
  lng: number,
  radiusMeters = 1500
): Array<{ lat: number; lng: number }> {
  const latDelta = radiusMeters / 111320;
  const lngDelta = radiusMeters / (111320 * Math.cos((lat * Math.PI) / 180));

  return [
    { lat: lat + latDelta, lng: lng - lngDelta },
    { lat: lat + latDelta, lng: lng + lngDelta },
    { lat: lat - latDelta, lng: lng + lngDelta },
    { lat: lat - latDelta, lng: lng - lngDelta }
  ];
}

export function defaultPolygonFromViewport(
  viewport: any
): Array<{ lat: number; lng: number }> | null {
  if (!viewport) {
    return null;
  }

  const ne = viewport.getNorthEast();
  const sw = viewport.getSouthWest();

  return [
    { lat: ne.lat(), lng: sw.lng() },
    { lat: ne.lat(), lng: ne.lng() },
    { lat: sw.lat(), lng: ne.lng() },
    { lat: sw.lat(), lng: sw.lng() }
  ];
}

export function polygonPathsFromGeoLongLat(geoLongLat: number[][]): Array<{ lat: number; lng: number }> {
  const paths = geoLongLat.map(val => ({
    lat: val[1],
    lng: val[0]
  }));

  if (paths.length > 1) {
    const first = paths[0];
    const last = paths[paths.length - 1];

    if (first.lat === last.lat && first.lng === last.lng) {
      paths.pop();
    }
  }

  return paths;
}
